<div class="login-box">
  <div class="login-logo">
    <app-logo [hide]='"mini"'></app-logo>
  </div>
  <div class="card">
    <div class="card-body login-card-body">
      <h3 class="recovery-title">{{ translate.instant('PAGES.ktidentityLink.title') }}</h3>

      <ng-container *ngIf="state === 'pending' || state === 'error'">
        <p class="login-box-msg">{{ translate.instant('PAGES.ktidentityLink.instructions') }}</p>
        <div *ngIf="state === 'error'" class="alert alert-danger" role="alert">
          {{ translate.instant('PAGES.ktidentityLink.unavailable') }}
        </div>
        <div class="row">
          <div class="col-6">
            <button type="button" class="btn btn-primary btn-block btn-flat" [disabled]="submitting" (click)="confirm()">
              {{ translate.instant('PAGES.ktidentityLink.confirm') }}
            </button>
          </div>
        </div>
      </ng-container>

      <div *ngIf="state === 'confirmed'" class="alert alert-success" role="status">
        {{ translate.instant('PAGES.ktidentityLink.confirmed') }}
      </div>
      <div *ngIf="state === 'invalid'" class="alert alert-danger" role="alert">
        {{ translate.instant('PAGES.ktidentityLink.invalid') }}
      </div>

      <div *ngIf="state === 'confirmed' || state === 'invalid'" class="row">
        <div class="col-12">
          <a routerLink="/login" class="btn btn-primary btn-block btn-flat">{{ translate.instant('PAGES.ktidentityLink.goToLogin') }}</a>
        </div>
      </div>
    </div>
  </div>
</div>
